/*
 * Kroslo Build Your Bundle: pricing engine (pure, no DOM).
 *
 * Ladder is always "% off MRP" and applies to EVERY eligible piece in the
 * cart. Sets and other non-eligible lines never reach this engine.
 * Money is in paise (integers), exactly like Shopify's /cart.js.
 *
 * Tested by Website/BYOB-festive/tests/engine.test.js. Re-run it after any edit.
 */
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.KBXEngine = factory();
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var DEFAULT_TIERS = [
    { min: 1, pct: 20 },
    { min: 2, pct: 24 },
    { min: 3, pct: 28 },
    { min: 4, pct: 33 },
    { min: 5, pct: 36 }
  ];
  var MAX_PCT = 60; // a typo in the tier setting can never create a giveaway

  function normalizeTiers(input) {
    var list = Array.isArray(input) ? input : (input && Array.isArray(input.tiers) ? input.tiers : null);
    if (!list) return DEFAULT_TIERS.slice();
    var byMin = {};
    list.forEach(function (t) {
      if (!t) return;
      var min = parseInt(t.min, 10);
      var pct = Number(t.pct);
      if (!isFinite(min) || min < 1 || !isFinite(pct) || pct < 0 || pct > MAX_PCT) return;
      byMin[min] = { min: min, pct: pct };
    });
    var out = Object.keys(byMin).map(function (k) { return byMin[k]; })
      .sort(function (a, b) { return a.min - b.min; });
    return out.length ? out : DEFAULT_TIERS.slice();
  }

  function tierIndexFor(tiers, pieces) {
    var idx = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (pieces >= tiers[i].min) idx = i; else break;
    }
    return idx;
  }

  /* Price of one piece at a given % off its MRP, in paise. */
  function unitAtPct(mrp, pct) {
    return Math.round(mrp * (100 - pct) / 100);
  }

  /*
   * lines: [{ key, vid, qty, mrp, price }] with mrp/price in paise.
   * Lines with no usable MRP fall back to their price as MRP.
   */
  function compute(lines, tiersInput) {
    var tiers = normalizeTiers(tiersInput);
    var pieces = 0;
    var clean = [];
    (lines || []).forEach(function (l) {
      var qty = parseInt(l && l.qty, 10);
      if (!l || !isFinite(qty) || qty < 1) return;
      var price = Math.max(0, Math.round(Number(l.price) || 0));
      var mrp = Math.round(Number(l.mrp) || 0);
      if (!(mrp > 0) || mrp < price) mrp = price;
      pieces += qty;
      clean.push({ key: l.key, vid: l.vid, qty: qty, mrp: mrp, price: price });
    });

    var idx = pieces > 0 ? tierIndexFor(tiers, pieces) : -1;
    var tier = idx >= 0 ? tiers[idx] : null;
    var pct = tier ? tier.pct : 0;
    var next = tiers[idx + 1] || null;

    var mrpTotal = 0, total = 0, nextTotal = 0;
    var priced = clean.map(function (l) {
      var unit = tier ? unitAtPct(l.mrp, pct) : l.price;
      mrpTotal += l.mrp * l.qty;
      total += unit * l.qty;
      if (next) nextTotal += unitAtPct(l.mrp, next.pct) * l.qty;
      return { key: l.key, vid: l.vid, qty: l.qty, mrp: l.mrp, price: l.price,
               unit: unit, lineTotal: unit * l.qty, lineMrp: l.mrp * l.qty };
    });

    return {
      tiers: tiers,
      lines: priced,
      pieces: pieces,
      tierIndex: idx,
      tier: tier,
      pct: pct,
      mrpTotal: mrpTotal,
      total: total,
      savings: mrpTotal - total,
      next: next,
      toNext: next ? next.min - pieces : 0,
      /* extra money saved on the pieces ALREADY in the cart once the next
         tier is reached; the new piece's own saving comes on top */
      extraOnExisting: next ? total - nextTotal : 0,
      isMax: pieces > 0 && !next,
      isEmpty: pieces === 0
    };
  }

  /* The ladder % a cart with `pieces` single pieces gets (0 when empty). */
  function pctFor(tiersInput, pieces) {
    var tiers = normalizeTiers(tiersInput);
    var idx = tierIndexFor(tiers, pieces);
    return idx >= 0 ? tiers[idx].pct : 0;
  }

  /* Whole rupees when there are no paise, otherwise exact to the paisa
     (e.g. 2,329.60), so every line always adds up to the total, as Shopify charges. */
  function formatINR(paise) {
    var p = Math.round(Number(paise) || 0);
    var neg = p < 0;
    p = Math.abs(p);
    var rupees = Math.floor(p / 100), rem = p % 100;
    var s = String(rupees);
    var last3 = s.slice(-3), rest = s.slice(0, -3);
    if (rest) last3 = "," + last3;
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    return (neg ? "-" : "") + "₹" + rest + last3 + (rem ? "." + (rem < 10 ? "0" : "") + rem : "");
  }

  return {
    DEFAULT_TIERS: DEFAULT_TIERS,
    normalizeTiers: normalizeTiers,
    tierIndexFor: tierIndexFor,
    unitAtPct: unitAtPct,
    compute: compute,
    pctFor: pctFor,
    formatINR: formatINR
  };
});
